/**
 * @generated SignedSource<<4a08b2b5630df44bc3fefa4b8943648b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type promoTracking_promotion$data = {
  readonly linkData: {
    readonly path: string | null;
  };
  readonly " $fragmentType": "promoTracking_promotion";
};
export type promoTracking_promotion$key = {
  readonly " $data"?: promoTracking_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"promoTracking_promotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "promoTracking_promotion"
};

(node as any).hash = "8fb7956a7ddf136b963317238bb5545e";

export default node;
